<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>
        <span style="color:#0cabc2">Drivers</span>
      </v-toolbar-title>

      <v-dialog v-model="dialog" max-width="500px">
        <v-btn slot="activator" color="primary" dark class="mb-2">New Driver</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12 lg612 xl12>
                  <v-text-field v-model="editedItem.username" label="Driver's username"></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm12 md12>
                  <v-text-field v-model="editedItem.password" label="Password" :type="'password'"></v-text-field>
                </v-flex> -->
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="editedItem.nickname" label="Nickname"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="editedItem.phone"   type="number"
                         label="Phone"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="editedItem.imei"   type="number"
                         label="Imei"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 xl12>
                      <!-- <v-text-field v-model="editedItem.type" label="type"></v-text-field> -->
                       <v-select
                    item-text="type"
                    item-value="type"
                    :items="typeList"
                    v-model="editedItem.user_type"
                    label="User Priority"
                    persistent-hint
                    single-line
                  ></v-select>

                    </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="close">Cancel</v-btn>
            <v-btn color="primary" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search Drivers"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>
    <p v-if="errors.length">
      <v-alert :value="true" color="error" type="error" dismissible outline>{{ errors }}</v-alert>
    </p>

    <v-data-table :headers="headers" :items="desserts" :search="search" disable-initial-sort class="elevation-1">
      <template slot="items" slot-scope="props">
         <tr
          :style="{backgroundColor: (props.item.status == '1' ? '#f4424226' : '#ffffff' ) }"
        >
        <td><b>{{ props.item.username }}</b></td>
        <td class="text-xs-right">{{ props.item.nickname }}</td>
        <td class="text-xs-right">{{ props.item.phone }}</td>
        <td class="text-xs-right">{{ props.item.imei }}</td>
        <td class="text-xs-right">{{ props.item.user_type }}</td>
        <td class="justify-end layout px-5">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
        </tr>
      </template>
  
      <v-alert slot="no-results" :value="true" color="primary" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
    </v-data-table>
      <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
  
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";

export default {
  data: () => ({
    search: '',
    snackbar: false,
    dialog: false,
    ERROR_corrnnection: false,
    errors: "",
    typeList:[{ type: "normal" },{ type: "high priority driver"}],
    baseUrl: baseUrl,
    headers: [
      {
        text: "Driver's  Name",
        value: "username"
      },

      { text: "Nickname", align: "right", value: "nickname" },
      { text: "Phone", align: "right", value: "phone" },
     { text: "Imei", align: "right", value: "imei" },
     { text: "Priority", align: "right", value: "user_type" },
      { text: "Actions", align: "right", value: "id", sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      username: "",
      phone: 0,
      nickname: "",
      imei: "",
      user_type: ""
    },
    defaultItem: {
      username: "",
      phone: 0,
      nickname: "",
      imei:"",
      user_type:""
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Driver" : "Edit Driver";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

   methods: {
    initialize() {
      const params = new URLSearchParams();
      params.append("getAllDriverList", "getAllDriverList");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/user/user.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.desserts = response.data.data;
          } else if (response.data.error == true) {
            this.errors = response.data.message;

            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {

      var id = item.id;
      var status = item.status;
      const params = new URLSearchParams();
      params.append("driver_id", id);
      params.append("delete_driver", "delete_driver");
       params.append("status", status);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/user/user.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.$emit("driver");
            this.initialize();
            // const index = this.desserts.indexOf(item);
            // this.desserts.splice(index, 1);
          } else if (response.data.error == true) {
            this.errors = response.data.message;

            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }

        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        // console.log("edited data");
        // console.log(this.editedItem);

        var id = this.editedItem.id;
        var username = this.editedItem.username;
        var imei = this.editedItem.imei;
        var user_type = this.editedItem.user_type;
        var nickname = this.editedItem.nickname;
        var phone = this.editedItem.phone;

        const params = new URLSearchParams();
        params.append("driver_id", id);
        params.append("username", username);
        params.append("imei", imei);
        params.append("user_type", user_type);
        params.append("nickname", nickname);
        params.append("phone", phone);
        params.append("update_driver", "update_driver");

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/user/user.php",
          data: params
        }).then(response => {
          if (response.data.error == false) {
             this.$emit("driver");
            this.initialize();
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        });


      } else {
        const params = new URLSearchParams();

        params.append("create_driver", "create_driver");
        params.append("username", this.editedItem.username);
        params.append("imei", this.editedItem.imei);
        params.append("nickname", this.editedItem.nickname);
        params.append("phone", this.editedItem.phone);
        params.append("user_type", this.editedItem.user_type);
        
        console.log(this.editedItem.user_type);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/user/user.php",
          data: params
        }).then(response => {
          if (response.data.error == false) {
             this.$emit("driver");
            this.initialize();
          } else if (response.data.error == true) {
            this.errors = response.data.message;

            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
              this.initialize();
        });

      }
      this.close();
    }
  }
};
</script>

